module.exports = __webpack_public_path__ + "img/VASOFONO-SELE.5276f1a1.jpg";